import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxCurrencyModule } from 'ngx-currency-custom';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskModule } from 'ngx-mask';

import { MetricConversionPipe, RnplCommonModule } from 'common/src/modules/rnpl-common';
import { DeliveryCostFormComponent } from './delivery-cost-form.component';
import { UIComponentsModule } from 'common/src/modules';
import { VatRatesDropdownModule } from '../vat-rates-dropdown/vat-rates-dropdown.module';

@NgModule({
  declarations: [
    DeliveryCostFormComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    UIComponentsModule,
    NgxMaskModule,
    NgxCurrencyModule,
    RnplCommonModule,
    TranslateModule,
    VatRatesDropdownModule
  ],
  exports: [DeliveryCostFormComponent],
  entryComponents: [DeliveryCostFormComponent],
  providers: [MetricConversionPipe]
})
export class DeliveryCostFormModule { }
